import { useEffect } from 'react'
import { saveChatPersist } from '@/features/chat/chatPersist'

/**
 * Best-effort persistence of chat shell state.
 * @param {object} m — return value of `useAppShellChatModel`
 */
export function useAppShellChatPersistence(m) {
  const {
    homeView,
    selectedThreadId,
    threads,
    pinnedThreadIds,
    messagesByThreadId,
    activeQueryVersionByExchangeId,
    activeAnswerVersionByExchangeId,
    dismissedNoteThreadIds,
  } = m

  useEffect(() => {
    saveChatPersist({
      homeView,
      selectedThreadId,
      threads,
      dismissedNoteThreadIds,
      pinnedThreadIds,
      messagesByThreadId,
      activeQueryVersionByExchangeId,
      activeAnswerVersionByExchangeId,
    })
  }, [
    homeView,
    selectedThreadId,
    threads,
    dismissedNoteThreadIds,
    pinnedThreadIds,
    messagesByThreadId,
    activeQueryVersionByExchangeId,
    activeAnswerVersionByExchangeId,
  ])
}
